<template>
  <!-- 仪表盘 -->
  <div class="window">
    <div class="header">
      <span class="title">欢迎您,{{ nick_name || "--" }}</span>
    </div>
    <div class="annotation">
      <span>以下是当前的任务统计数据</span>
    </div>
    <div class="task">
      <div
        class="unify"
        :style="{ backgroundImage: item.bgcolor, boxShadow: item.shadow }"
        v-for="(item, index) in todo_Data"
        :key="index"
      >
        <div class="box-title">
          <div class="word">{{ item.name }}</div>
          <div class="card-title">
            <span>{{ item.count }} </span>
            <img class="card-img" :src="item.img" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 统计图模块 -->
    <div class="chartbox">
      <div>清单完成分析</div>
      <div class="chart" id="main" style=" height:100%"></div>
    </div>
  </div>
</template>


<script>
import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GridComponent, BarChart, CanvasRenderer]);

export default {
  data() {
    return {
      nick_name: "",
      tododata: [],
      todo_Data: [
        {
          name: "全部待办",
          count: 0,
          bgcolor:
            "linear-gradient(54deg,	#8383fb 0%, #8aa6fd 100%), linear-gradient(#c6c6c6, #c6c6c6)",
          img: require("../../assets/img/dashboard/all.png"),
          shadow: "0px 8px 16px 0px rgba(83, 82, 255, 0.25)",
        },
        {
          name: "今天",
          count: 0,
          bgcolor:
            "linear-gradient(54deg, #f89343 0%,	#fcb468 100%), linear-gradient(#c6c6c6, #c6c6c6)",
          img: require("../../assets/img/dashboard/today.png"),
          shadow: "0px 8px 16px 0px rgba(255, 115, 0, 0.25)",
        },
        {
          name: "未来七天",
          count: 0,
          bgcolor:
            "linear-gradient(54deg, #67acff 1%, #7bc2f0 100%),linear-gradient(#c6c6c6, #c6c6c6)",
          img: require("../../assets/img/dashboard/future.png"),
          shadow: "0px 8px 16px 0px rgba(71, 151, 251, 0.25)",
        },
        {
          name: "已过期",
          count: 0,
          bgcolor:
            "linear-gradient(54deg, #a13efe 1%, #c589fc 100%), linear-gradient(#c6c6c6, #c6c6c6)",
          img: require("../../assets/img/dashboard/formerly.png"),
          shadow: "0px 8px 16px 0px rgba(172, 45, 252, 0.25)",
        },
      ],

      chartOption: {
        darkMode: "auto",
        color: "#4973f5",
        legend: {
          padding: [0, 0, 0, 0],
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [],
            type: "bar",
            label: {
              show: true,
              position: "top",
              valueAnimation: true,
            },
          },
        ],
      },
    };
  },
  watch: {
    "$store.state.theme.theme"(val) {
      console.log(val, "坚挺的数据");
      if (val === "dark") {
        this.initHistogramChar("dark");
      } else {
        this.initHistogramChar();
      }
    },
  },
  methods: {
    // 获取几天前、今天、几天后的日期、星期
    getDay(day) {
      let weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      let week = weekDay[new Date(tYear + "-" + tMonth + "-" + tDate).getDay()];
      let obj = [tYear + "-" + tMonth + "-" + tDate, week];
      return obj;
    },

    doHandleMonth(month) {
      let m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },

    initHistogramChar(val) {
      console.log(val, "暗黑模式切换");
      let chartDom = document.getElementById("main");
      let myChart = val
        ? echarts.init(chartDom, "dark")
        : echarts.init(chartDom);

      this.chartOption && myChart.setOption(this.chartOption);

      setTimeout(() => {
        myChart.resize();
      }, 200);
    },

    // 查询数据
    queryData() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .navnumbar("", header)
        .then((res) => {
          console.log(res, "查询条目数");
          this.tododata = res.data.result[0].todo_data;
          console.log(this.tododata, "查询的清单数据");
          this.tododata.forEach((item) => {
            if (item.name == "全部事项") {
              this.todo_Data[0].count = item.count;
            }
            if (item.name == "今天") {
              this.todo_Data[1].count = item.count;
            }
            if (item.name == "未来七天") {
              this.todo_Data[2].count = item.count;
            }
            if (item.name == "已过期") {
              this.todo_Data[3].count = item.count;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 查询本周数据
    queryWeek() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api.weekday(this.getDay(0)[0], header).then((res) => {
        console.log(res, "柱状图数据");
        let data = res.data.result;
        let data1 = [];
        for (let i = 0; i < data.length; i++) {
          data1.push(data[i].length);
        }
        this.chartOption.series[0].data = data1;
        this.initHistogramChar();
      });
    },

    //查询用户头像昵称
    UserInformation() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .queryUserNickImg("", header)
        .then((res) => {
          this.nick_name = res.data.results.nick_name;
          console.log(this.userInfo, "用户信息");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {},
  created() {
    console.log(this.$store.state.theme.theme, "vuex胡数据");
    this.queryData();
    this.UserInformation();
    this.queryWeek();
  },
};
</script>

<style lang="scss" scoped>
.window {
  width: 100%;
  height: 100%;
  padding: 0 39px;
  box-sizing: border-box;
  overflow: hidden;
}
.header {
  margin-top: 15px;
}
.title {
  font-size: 40px;
  font-weight: bold;
}
.annotation {
  margin-top: 24px;
  font-size: 20px;
  font-weight: bold;
  color: #c6c6c6;
}
.task {
  display: flex;
  justify-content: space-between;
}
.unify {
  width: 20%;
  height: 9%;
  margin-top: 22px;
  border-radius: 14px;
}

.word {
  font-size: 24px;
  color: #ffffff;
  opacity: 0.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-title {
  margin-top: 25px;
  margin-left: 30px;
  margin-right: 52px;
}
.card-title {
  margin-top: 10px;
  font-size: 50px;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .card-img {
    width: 27px;
    height: 27px;
  }
}
.chartbox {
  width: 100%;
  height: calc(100% - 300px);
  padding: 31px 0;
  box-sizing: border-box;
  background-color: #ffffff;
  margin-top: 24px;
  border-radius: 10px;

  div:nth-child(1) {
    padding: 0 50px;
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
  }

  .chart {
    width: 100%;
    height: 100%;

    div {
      width: 100%;
      height: 100%;
      canvas {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>